'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('component/io', ['require'], function (require) {
  'use strict';

  var ERROR_CODE_HTTP = 90010001;
  var ERROR_CODE_IO = 90010002;

  var IO = function () {
    function IO() {
      _classCallCheck(this, IO);
    }

    _createClass(IO, null, [{
      key: 'call',
      value: function call(url) {
        var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
        var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'POST';

        if (typeof url !== 'string' || url[0] !== '/' || url.indexOf('?') !== -1) {
          throw new Error('url(' + url + ') should be a string which started with \'/\'');
        }
        if (param !== undefined && !$.isPlainObject(param)) {
          throw new Error('param(' + param + ') should be a plain object');
        }
        if (method !== 'GET' && method !== 'POST') {
          throw new Error('method(' + method + ') must be GET or POST');
        }

        return $.ajax({
          method: method,
          url: '/fe/ic,' + url,
          data: method === 'GET' ? param : JSON.stringify(param),
          contentType: method === 'GET' ? undefined : 'application/json',
          dataType: 'json'
        }).then(function (res) {
          if (isValidIoJson(res)) {
            res.$rawMessage = res.message;
            res.message = res.message + ' [' + res.code + ']';
            return res;
          } else {
            return {
              result: false,
              code: ERROR_CODE_IO,
              $rawMessage: res.message,
              message: res.message + ' [' + res.code + ']',
              data: res.data
            };
          }
        }, function (errorResponse) {
          setTimeout(function () {
            // 异步抛出异常，便于跟踪和错误采集
            throw errorResponse;
          }, 0);
          return parseAjaxError(errorResponse);
        });
      }
    }, {
      key: 'union',
      value: function union(requestData) {
        var urlList = [];
        var paramObject = {};
        Object.keys(requestData).forEach(function (url) {
          var param = requestData[url];
          if (typeof url !== 'string' || url[0] !== '/' || url.indexOf('?') !== -1) {
            throw new Error('url(' + url + ') should be a string which started with \'/\'');
          }
          if (param !== undefined && $.isPlainObject(param)) {
            throw new Error('param(' + param + ') should be a plain object');
          }
          urlList.push(url);
          paramObject[url] = param;
        });

        return $.ajax({
          url: '/fe/iu,' + urlList.join(','),
          data: JSON.stringify(paramObject),
          contentType: 'application/json',
          dataType: 'json',
          headers: {
            'Tag': 'feature_1105405_i18n'
          }
        }).then(function (res) {
          if (isValidIoJson(res)) {
            res.$rawMessage = res.message;
            res.message = res.message + ' [' + res.code + ']';
            return res;
          } else {
            return {
              result: false,
              code: ERROR_CODE_IO,
              $rawMessage: res.message,
              message: res.message + ' [' + res.code + ']',
              data: res.data
            };
          }
        }, function (errorResponse) {
          setTimeout(function () {
            // 异步抛出异常，便于跟踪和错误采集
            throw errorResponse;
          }, 0);
          return parseAjaxError(errorResponse);
        });
      }
    }, {
      key: 'alertError',
      value: function alertError(response) {
        // TODO 按交互修改，与 buyer 相同。同时支持自定义文案和直接传递 response 对象
        alert(response.message);
      }
    }]);

    return IO;
  }();

  function isValidIoJson(obj) {
    return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && Number.isInteger(obj.code)
    // && typeof obj.message === 'string'
    && !(obj instanceof Error);
  }

  // 将错误错误转换为标准通信结构
  // 行为与其它站点相同
  function parseAjaxError(errorResponse) {
    // 内部异常时直接转义
    if (errorResponse instanceof Error) {
      return {
        result: false,
        code: ERROR_CODE_IO,
        message: errorResponse.message,
        data: undefined
      };
    }
    // 中间层正确响应了标准结构的JSON
    if (errorResponse.responseJSON && isValidIoJson(errorResponse.responseJSON)) {
      return errorResponse.responseJSON;
    }
    // 其他HTTP错误
    var toErrorData = function toErrorData(errorCode) {
      if (errorResponse.responseText) {
        return {
          result: false,
          code: errorCode,
          message: errorResponse.responseText,
          data: undefined
        };
      } else {
        return {
          result: false,
          code: errorCode,
          message: '(' + errorResponse.status + ') ' + errorResponse.statusText,
          data: undefined
        };
      }
    };
    var status = errorResponse.status,
        statusText = errorResponse.statusText;

    if (status === 0 && statusText === 'abort') {
      // 重定向等原因或手动abort(IO未支持但XHR支持)导致请求被cancel时
      // 延迟返回结果(通常延迟时间之后，页面已重定向)
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          resolve(toErrorData(ERROR_CODE_IO));
        }, 15 * 1000);
      });
    } else if (status === 0) {
      // 其余请求被cancel等异常，包括网络中断等
      // 跨域场景下，404等错误也可能被识别为 (0) error
      // 后续可考虑做断线重连
      // 不再对外暴露HTTP细节
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          resolve(toErrorData(ERROR_CODE_HTTP));
        }, 3 * 1000);
      });
    } else if (status > 0) {
      // 常规 HTTP 错误
      // 不再对外暴露HTTP细节
      return toErrorData(ERROR_CODE_HTTP);
    } else {
      // 其余异常，解析JSON错误等
      return toErrorData(ERROR_CODE_IO);
    }
  }

  return IO;
});